namespace advisorop.components.advisor {

    export class AdvisorMsgraphIntegrationRequestController {
        $router;     
        accountLinked: boolean = false;

        constructor(private generalService: services.GeneralService,
            private advisorService: services.AdvisorService) {
        }

        msgraphLinkRequest(): void {
            this.advisorService.msGraphIntegrationCheck()
                .then(data => {
                    var proceed: boolean = true;
                    this.accountLinked = (data.data == "ALREADY_LINKED")
                    if (this.accountLinked) {
                        this.getUserInfo();
                        this.get2WCalendar();
                        proceed = confirm(`It looks like your account is already linked. Link again?`);
                    }
                    if (proceed) {
                        this.advisorService.msGraphIntegrationRequest()
                            .then(data => {
                                window.open(data.data, "_blank");
                            })
                            .catch(err => { this.generalService.showError(err); });
                    } else {
                        toastr.warning("You have decided not to link at this time.");
                    }
                })
                .catch(err => {
                    console.log("ERROR: ", err);
                    toastr.error("Error, please contact AdvisorOp Support");
                });
        }

        getUserInfo(): void {
            this.advisorService.getAdvisorGraphUserInfo().then(resp => {
                //console.log(resp);
            }).catch(err => {
                console.log(err);
            })
        }

        get2WCalendar(): void {
            this.advisorService.getAdvisor2wCalendar().then(resp => {
                //console.log(resp);
            }).catch(err => {
                console.log(err);
            })
        }

        $onInit(): void {
        }

        $onChanges(evt): void {
        }

    }

    class AdvisorMsgraphIntegrationRequest implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "$router": "<",
            };
            this.controller = ["generalService", "advisorService", AdvisorMsgraphIntegrationRequestController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/advisor-msgraph-integration-request.html';
        }
    }
    angular.module(Constants.APP).component("advisorMsgraphIntegrationRequest", new AdvisorMsgraphIntegrationRequest());
}